import { Redirect, useLocation, useParams } from 'react-router-dom';

type LegacyTldRedirectProps = {
  baseUrl?: string;
};

export function LegacyTldRedirect({
  baseUrl = '',
}: LegacyTldRedirectProps = {}) {
  const { extraction_token } = useParams<{ extraction_token: string }>();
  const { search } = useLocation();
  const cleanBase = baseUrl.replace(/\/$/, ''); // strip trailing / just in case

  return (
    <Redirect
      to={`${cleanBase}/traffic-light-detection/${extraction_token}${search}`}
    />
  );
}
